import {Text} from "@atlaskit/primitives/compiled";
import type {ComponentProps} from "react";

export function AnankeText(props: ComponentProps<typeof Text>) {
    return <Text {...props} />;
}
